import { NextcladeDatasetInfo } from '../../data/NextcladeDatasetInfo';
import { ExternalLink } from '../../components/ExternalLink';
import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

const FooterStyle = styled.footer`
  margin-top: 50px;
  padding-top: 20px;
  border-top: 1px solid darkgray;
  font-size: small;
`;

export function Footer({
  nextcladeDatasetInfo,
  lapisDataVersion,
}: {
  nextcladeDatasetInfo?: NextcladeDatasetInfo;
  lapisDataVersion?: number;
}) {
  let lapisUpdateFormattedString = '';
  if (lapisDataVersion !== undefined) {
    lapisUpdateFormattedString = dayjs.unix(lapisDataVersion).locale('en').calendar();
  }
  return (
    <FooterStyle className='text-center'>
      {lapisUpdateFormattedString && <div>The sequence data was updated: {lapisUpdateFormattedString}</div>}
      {nextcladeDatasetInfo?.tag && <div>Nextclade dataset version: {nextcladeDatasetInfo.tag}</div>}
      <div className='flex flex-wrap justify-center items-center gap-x-8 gap-y-4 my-4 mt-8 px-2'>
        <ExternalLink url='https://ethz.ch'>
          <img className='h-5' alt='ETH Zurich' src='/img/ethz.png' />
        </ExternalLink>
        <ExternalLink url='https://bsse.ethz.ch/cevo'>
          <img className='h-7' alt='Computational Evolution Group' src='/img/cEvo.png' />
        </ExternalLink>
        <ExternalLink url='https://www.sib.swiss/'>
          <img className='h-7' alt='SIB Swiss Institute of Bioinformatics' src='/img/sib.svg' />
        </ExternalLink>
      </div>
    </FooterStyle>
  );
}
